import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FormItem from '../../../common/forms/FormItem';
import DatePicker from '../../../common/forms/input/DatePicker';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const ExpenseSapMigrationSearchForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar Egresos"
      saveButtonIcon="fa fa-search"
      saveButtonColor="secondary"
      saveButtonDisabled={loading}
    />
  </Form>
);

ExpenseSapMigrationSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ExpenseSapMigrationSearchForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: 'ExpenseSapMigrationSearchForm',
})(ExpenseSapMigrationSearchForm);